import { observer } from 'mobx-react-lite'
import { type OCRScopingJobsViewModel } from '@/features/jobs/scoping/OCRScopingJobsViewModel'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { CreateJobDialogContainer } from '@/features/jobs/drafting/components/CreateJobDialog/CreateJobDialogContainer'
import { OCRConfirmReviewDialogContainer } from '@/features/jobs/scoping/components/OCRConfirmReviewDialog/OCRConfirmReviewDialogContainer'
import { OCRConfirmSubmitDialogContainer } from '@/features/jobs/scoping/components/OCRConfirmSubmitDialog/OCRConfirmSubmitDialogContainer'
import { OCRConfirmArchiveDialogContainer } from '@/features/jobs/scoping/components/OCRConfirmArchiveDialog/OCRConfirmArchiveDialogContainer'
import { OCRScopingJobMainPanel } from '@/features/jobs/scoping/components/OCRScopingJobMainPanel'
import { OCRScopeJobDetailHeaderContainer } from '@/features/jobs/scoping/components/OCRScopeJobDetailHeader/OCRScopeJobDetailHeaderContainer'
import { OCRScopeJobDetailBodyContainer } from '@/features/jobs/scoping/components/OCRScopeJobDetailBody/OCRScopeJobDetailBodyContainer'
import { OCRScopeJobDetailFooterContainer } from '@/features/jobs/scoping/components/OCRScopeJobDetailFooter/OCRScopeJobDetailFooterContainer'

export interface OCRScopingJobMainPanelContainerProps {
  vm: OCRScopingJobsViewModel
}

export const OCRScopingJobMainPanelContainer = observer(
  function OCRScopingJobMainPanelContainer({
    vm,
  }: OCRScopingJobMainPanelContainerProps) {
    return vm.mainPanelVm.fetch.match({
      pending: () => <ContentLoading />,
      rejected: (err) => <ContentError error={err} />,
      resolved: () => (
        <OCRScopingJobMainPanel>
          <OCRScopeJobDetailHeaderContainer vm={vm.mainPanelVm} />
          <OCRScopeJobDetailBodyContainer vm={vm} />
          <OCRScopeJobDetailFooterContainer vm={vm.mainPanelVm} />
          <CreateJobDialogContainer vm={vm.mainPanelVm.createJobDialogVm} />
          <OCRConfirmReviewDialogContainer
            vm={vm.mainPanelVm.confirmReviewDialogVm}
          />
          <OCRConfirmSubmitDialogContainer
            vm={vm.mainPanelVm.confirmSubmitDialogVm}
          />
          <OCRConfirmArchiveDialogContainer
            vm={vm.mainPanelVm.confirmArchiveDialogVm}
          />
        </OCRScopingJobMainPanel>
      ),
    })
  },
)
